'use client'

import localFont from 'next/font/local'
import Image from 'next/image'
import Link from 'next/link'
import { Button } from '@/src/components/ui/button'

const ppEditorialNew = localFont({
  src: [
    {
      path: '../public/assets/fonts/PPEditorialNew-Ultralight-BF644b21500d0c0.otf',
      style: 'normal',
    },
    {
      path: '../public/assets/fonts/PPEditorialNew-UltralightItalic-BF644b214ff1e9b.otf',
      style: 'italic',
    },
  ],
  display: 'swap',
  variable: '--font-serif',
})

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang='en' className={`${ppEditorialNew.variable}`}>
      <body className='bg-background'>
        <main className='flex flex-col pb-20 h-screen px-page-gutter'>
          <div className='flex w-full py-6 items-center justify-center'>
            <Link href='/'>
              <Image
                src='/assets/logo.svg'
                alt='Polaris logo'
                width={107}
                height={32}
              />
            </Link>
          </div>
          <div className='flex flex-col gap-8 my-auto py-8 items-center justify-center text-center'>
            <Image
              src='/assets/ladybug.png'
              alt='Ladybug'
              width={240}
              height={240}
            />
            <div className='flex flex-col gap-6 items-center'>
              <div className='flex flex-col gap-4 text-center'>
                <h1 className='text-primary text-4xl font-serif font-extralight max-w-96'>
                  Oops, that wasn’t supposed to happen
                </h1>
                <p className='text-secondary'>
                  The app had a bit of a moment. We&#39;re on it.
                </p>
              </div>
              <Button
                type='button'
                size='md'
                variant='outline'
                onClick={() => reset()}
              >
                Reload the app
              </Button>
              <div className='text-tertiary text-sm max-w-md'>
                {error.digest
                  ? `Error digest ${error.digest}`
                  : JSON.stringify(error.message)}
              </div>
            </div>
          </div>
        </main>
      </body>
    </html>
  )
}
